import { Pointer, Wrapper, VerticalPointer } from './styled'
import { TooltipProps } from './types'

const TooltipButton = ({ children, verticalPointer }: TooltipProps) => {
  return (
    <Wrapper>
      {verticalPointer ? <VerticalPointer /> : <Pointer />}
      {children}
    </Wrapper>
  )
}

export default TooltipButton
